import helpers from './helpers';

export default {
  setData(state, payload) {
    state.data = payload.map(helpers.prepareResourceData);
  },
};
